export enum ATDLNOperator {
  // SINGLE PARAM
  EX, // is value specified for parameter
  NX, // is null specified for parameter
  // TWO PARAM (second can be value)
  LE, // is parameter less than or equal to secondary value
  LT, // is parameter less than or equal to secondary value
  GE, // is parameter greater than or equal to secondary value
  GT, // is parameter greater than to secondary value
  EQ, // is parameter equal to secondary value
  NE, // is parameter not equal to secondary value
}
